import { render } from "./TestDriveFormUsados.vue?vue&type=template&id=fdfdd93e&scoped=true"
import script from "./TestDriveFormUsados.vue?vue&type=script&lang=js"
export * from "./TestDriveFormUsados.vue?vue&type=script&lang=js"

import "./TestDriveFormUsados.vue?vue&type=style&index=0&id=fdfdd93e&lang=scss&scoped=true"

import exportComponent from "/home/rubb/NiwCaetano/Frontend/governance/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdfdd93e"]])

export default __exports__